import { FunctionComponent, ReactElement, useContext, useMemo } from "react";

import { DraggableItemsContext } from "./DraggableItemsContextProvider";
import { DraggableItem } from "./types";

export type DraggableItemProviderComponentChildrenProps = {
    /** Prvek daného ID. */
    readonly item: DraggableItem;
};

type DraggableItemProviderProps = {
    /** ID prvku stromu. */
    readonly itemId: string;
    readonly children: (props: DraggableItemProviderComponentChildrenProps) => ReactElement;
};

/** Komponenta se chová jako takový pseudo selector, kdy odstiňuje logiku memoizace konkrétního prvku stromu. */
export const DraggableItemProvider: FunctionComponent<DraggableItemProviderProps> = ({ itemId, children }) => {
    const draggableItemsContext = useContext(DraggableItemsContext);
    const item = draggableItemsContext?.getDraggableItem(itemId);

    if (item === undefined)
        throw new Error(`No item of given id '${itemId}' was found!`);

    return useMemo(() => children({ item }), [children, item]);
};
